import { connect } from 'react-redux'
import { getProp } from '../../../../../../redux/selectors/kegCollectionBookings'

import FormSuccessMessage from './BookingsGeneralNotificationMessage'

const mapStateToProps = state => {
  const { bookingsNotificationMessageState } = getProp(state)
  return {
    isShowing: bookingsNotificationMessageState.isShowing,
    header: bookingsNotificationMessageState.header,
    content: bookingsNotificationMessageState.content,
    isError: bookingsNotificationMessageState.isError,
  }
}

export default connect(mapStateToProps)(FormSuccessMessage)
